export default __webpack_public_path__ + "static/1-60b7e827ef034f81afce5ceb29a83874.jpg";